<template>
  <div :class="['home-slider', 'flex', 'flex-column', wrapperClass]">
    <div class="container">
      <el-carousel :interval="500000" arrow="never" indicator-position="none" height="360px" @change="changeWrapperClassName">
        <el-carousel-item key="0">
          <div class="home-slider-0-content">
            <img class="home-slider-0-content-logo" src="../../assets/image/logo/dbg_logo241113_large.svg" alt="" srcset="">
            <p class="home-slider-0-content-title">{{ $t("home.slider.banner1.title") }}</p>
          </div>
        </el-carousel-item>
        <!-- <el-carousel-item key="1">
          <img src="../../assets/image/home/banner-title-en.png" alt="" srcset="" v-if="$i18n.locale == 'en'" class="item-img-2">
          <img src="../../assets/image/home/banner-title.png" alt="" srcset=""  class="item-img-2">
          <ul class="advantage-list flex">
            <li v-for="(adv, index) of advantageList" :key="index" class="flex flex-column">
              <span>{{ adv.title }}</span>
              <span class="sub-text">{{ adv.subText }}</span>
            </li>
          </ul>
          <div class="flex btn-group flex__justify-center">
            <div class="btn active"  :class="{'btn-locale': $i18n.locale == 'en'}" @click="$open('signUp', $i18n.locale)">
              <span class="icon"></span>
              <span>{{$t('home.slider.common.openRealAccount')}}</span>
            </div>
            <div class="btn"  :class="{'btn-locale': $i18n.locale == 'en'}" @click="$open('signUp5', $i18n.locale)">
              <span class="icon"></span>
              <span>{{$t('home.slider.common.openRealAccount5')}}</span>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="2">
          <h4 :class="{'h4-locale': $i18n.locale == 'en'}">{{$t("home.slider.banner3.describe1")}}</h4>
          <p>{{$t("home.slider.banner3.describe2")}} </p>
          <div class="flex btn-group flex__justify-center" :style="{'margin-top': '150px'}">
            <div class="btn active"  :class="{'btn-locale': $i18n.locale == 'en'}" @click="$open('signUp', $i18n.locale)">
              <span class="icon"></span>
              <span>{{$t('home.slider.common.openRealAccount')}}</span>
            </div>
            <div class="btn" :class="{'btn-locale': $i18n.locale == 'en'}" @click="$open('signUp5', $i18n.locale)">
              <span class="icon"></span>
              <span>{{$t('home.slider.common.openRealAccount5')}}</span>
            </div>
          </div>
        </el-carousel-item> -->
      </el-carousel>
    </div>
  </div>
</template>

<script>
import HomeHeader from '@/components/header/header';

export default {
  name: 'slider',

  components: {
    HomeHeader
  },

  data() {
    return {
      activeIndex: 0,
    }
  },
  computed: {
    advantageList() {
      return [
        {
          title: this.$t("home.slider.banner2.tabTitle1"),
          subText: this.$t("home.slider.banner2.tabSubText1"),
        },
        {
          title: this.$t("home.slider.banner2.tabTitle2"),
          subText: this.$t("home.slider.banner2.tabSubText2"),
        },
        {
          title: this.$t("home.slider.banner2.tabTitle3"),
          subText: this.$t("home.slider.banner2.tabSubText3"),
        }
      ];
    },
    wrapperClass() {
      let cl = this.$i18n.locale == 'en' ? `home-slider-en home-slider-${this.activeIndex}-en home-slider-${this.activeIndex}` : `home-slider-${this.activeIndex}`
      return cl
    }
  },

  methods: {
    changeWrapperClassName(index) {
      this.activeIndex = index;
    }
  }
}
</script>

<style scoped lang="scss">
.home-slider {
  height: 360px;
  background-size: cover;
  background-position: center center;
  background-color: black;
  &-0{
    @include bg-image('../../assets/image/home/slider1');
    background-position: center center;
    &-content{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      &-logo{
        width: 70px;
        height: 80px;
      }
      &-title{
        margin-top: 12px;
        max-width: 480px;
        font-size: 24px;
        line-height: 32px;
        font-weight: bold;
        text-align: center;
        color: #fff
      }
    }
  }
  &-1 {
    @include bg-image('../../assets/image/home/slider2');
    background-position: center center;
  }
  &-2 {
    @include bg-image('../../assets/image/home/slider3');
    background-position: center center;
    text-align: center;
    h4 {
      height: 30px;
      font-size: 22px;
      font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 30px;
      text-shadow: 0px 3px 10px rgba(0,0,0,0.5000);
    }
    .h4-locale{
      height: 60px;
    }
    p {
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC;
      color: rgba(255, 255, 255, 0.9);
      line-height: 25px;
      text-shadow: 0px 2px 4px rgba(0,0,0,0.3000);
      margin-top: 13px;
      /*margin-bottom: 124px;*/
    }
  }
  &-0-en{
    // @include bg-image('../../assets/image/home/slider1-en');
  }

  .el-carousel__item {
    padding:60px 40px;
    .title {
      font-size: 50px;
    }
    .advantage-list {
      margin-top: 30px;
      li {
        margin-right: 20px;
        &::before {
          content: '';
          display: inline-block;
          width: 24px;
          height: 6px;
          background: #FFFFFF;
          border-radius: 4px;
        }
        span {
          margin-top: 10px;
          font-size: 16px;
          color: #ffffff;
          &.sub-text {
            font-size: 14px;
            font-weight: 400;
            margin-top: 6px;
            padding: 3px 0;
            color: rgba(255, 255, 255, .6);
          }
        }
      }
    }
    .btn-group {
      margin-top: 65px;
      .btn {
        font-size: 12px;
        color: #fff;
        border: 1px solid #fff;
        font-weight: normal;
        width: 220px;
        height: 30px;
        min-width: unset;
        text-align: center;
        line-height: 30px;
        transition: color 0.3s;
        white-space: nowrap;
        padding: 0 12px;
        margin: 0 8px;
        .icon {
          display: inline-block;
          vertical-align: text-top;
          margin-right: 4px;
          width: 12px;
          height: 12px;
          background-image: url(../../assets/image/home/icon-person.png);
          background-size: cover;
        }
        span {
          height: 22px;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 22px;
        }

      }
      .btn-locale{
        width: 300px;
      }
      .active {
        background-color: #fff;
        color: #0D73D6;
        .icon {
          background-image: url(../../assets/image/home/icon-person-active.png);
        }
        span {
          color: #0D73D6;
        }
      }
    }
  }
  /deep/ .el-carousel__indicator--horizontal {
    padding: 12px 7px;
    .el-carousel__button {
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }
  }
}
.item-img-2{
  width: 80vw;
  object-fit: cover;
}
.home-slider-en .btn{
  min-width: 190px;
}
.home-slider-0-en .btn-group{
  margin-top: 40px !important;
}
  @media screen and (min-width: 992px) and(max-width: 1200px) {
    .home-slider{
      /*width: 1200px;*/
    }
  }

  @media screen and (min-width: 768px) and(max-width: 992px) {
    .container{
      width: 100vw;
    }
  }
  @media screen and (max-width: 768px) {
    .container{
      width: 100vw;
    }
  }
</style>
